import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

const TRACKER_SCRIPT_SELECTOR =
    'script[src="https://sdk.rcbt-sip.com/tracker-sdk.js"]';
const PARTICIPANT_INFORMATION_SHEET_URL =
    "https://drive.google.com/drive/folders/1z7FoVwSF4PH4rcWILzPLZYPyW4yLTnw_?usp=sharing";
const EXTRA_ACTIONS_SELECTOR = "cc-granular-actions";

const applyTrackerConsent = (granted) => {
    const consentState = granted ? "GRANTED" : "DENIED";
    const trackerScript = document.querySelector(TRACKER_SCRIPT_SELECTOR);

    if (trackerScript) {
        trackerScript.dataset.consent = consentState;
    }

    if (
        window.RCBTTracker &&
        typeof window.RCBTTracker.setConsent === "function"
    ) {
        window.RCBTTracker.setConsent(consentState);
    }

    if (
        window.trackerSDK &&
        typeof window.trackerSDK.setConsent === "function"
    ) {
        window.trackerSDK.setConsent(consentState);
    }
};

const syncTrackerConsentFromCookie = () => {
    const researchGranted =
        CookieConsent.acceptedCategory("behavioralResearch");
    applyTrackerConsent(Boolean(researchGranted));
};

const setGranularConsent = (mode) => {
    if (mode === "all") {
        CookieConsent.acceptCategory("all");
    } else if (mode === "website") {
        CookieConsent.acceptCategory(["necessary", "analytics"]);
    } else if (mode === "research") {
        CookieConsent.acceptCategory(["necessary", "behavioralResearch"]);
    } else {
        CookieConsent.acceptCategory(["necessary"]);
    }

    syncTrackerConsentFromCookie();
    CookieConsent.hide();
};

const addGranularConsentButtons = () => {
    const buttonContainer = document.querySelector(".cm__btns");
    if (!buttonContainer) {
        return;
    }

    if (buttonContainer.querySelector(`.${EXTRA_ACTIONS_SELECTOR}`)) {
        return;
    }

    const wrapper = document.createElement("div");
    wrapper.className = EXTRA_ACTIONS_SELECTOR;
    wrapper.style.display = "flex";
    wrapper.style.flexWrap = "wrap";
    wrapper.style.gap = "8px";
    wrapper.style.marginTop = "8px";
    wrapper.style.width = "100%";

    const createButton = (label, mode) => {
        const button = document.createElement("button");
        button.type = "button";
        button.textContent = label;
        button.style.padding = "10px 12px";
        button.style.border = "1px solid #1c5b9d";
        button.style.borderRadius = "8px";
        button.style.background = "#ffffff";
        button.style.color = "#1c5b9d";
        button.style.fontWeight = "600";
        button.style.cursor = "pointer";
        button.style.flex = "1 1 230px";
        button.addEventListener("click", () => setGranularConsent(mode));
        return button;
    };

    const websiteButton = createButton(
        "ยอมรับการใช้งานเว็บไซต์ทั่วไป (ข้อมูลการใช้งานเว็บไซต์จะไม่ถูกใช้เพื่อการวิเคราะห์ในงานวิจัย)",
        "website",
    );
    const researchButton = createButton(
        "ยอมรับการเข้าร่วมโครงการวิจัยเชิงพฤติกรรม (ข้อมูลการใช้งานเว็บไซต์จะถูกใช้เพื่อการวิเคราะห์เชิงพฤติกรรม)",
        "research",
    );

    const infoLink = document.createElement("a");
    infoLink.href = PARTICIPANT_INFORMATION_SHEET_URL;
    infoLink.target = "_blank";
    infoLink.rel = "noopener noreferrer";
    infoLink.textContent = "เปิดอ่านเอกสารชี้แจงผู้เข้าร่วมการวิจัย";
    infoLink.style.display = "inline-flex";
    infoLink.style.alignItems = "center";
    infoLink.style.justifyContent = "center";
    infoLink.style.padding = "10px 12px";
    infoLink.style.borderRadius = "8px";
    infoLink.style.background = "#1c5b9d";
    infoLink.style.color = "#ffffff";
    infoLink.style.fontWeight = "600";
    infoLink.style.textDecoration = "none";
    infoLink.style.flex = "1 1 280px";

    wrapper.appendChild(websiteButton);
    wrapper.appendChild(researchButton);
    wrapper.appendChild(infoLink);
    buttonContainer.appendChild(wrapper);
};

const watchConsentModal = () => {
    if (window.__cookieConsentObserverInitialized) {
        return;
    }

    window.__cookieConsentObserverInitialized = true;
    const observer = new MutationObserver(() => {
        addGranularConsentButtons();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    addGranularConsentButtons();
};

const initCookieConsent = () => {
    if (window.__cookieConsentInitialized) {
        return;
    }

    window.__cookieConsentInitialized = true;

    CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: "cloud",
                position: "bottom center",
                equalWeightButtons: true,
                flipButtons: false,
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                equalWeightButtons: true,
                flipButtons: false,
            },
        },
        categories: {
            necessary: {
                readOnly: true,
            },
            analytics: {},
            behavioralResearch: {},
        },
        onFirstConsent: () => {
            syncTrackerConsentFromCookie();
        },
        onConsent: () => {
            syncTrackerConsentFromCookie();
        },
        onChange: () => {
            syncTrackerConsentFromCookie();
        },
        language: {
            default: "en",
            translations: {
                en: {
                    consentModal: {
                        title: "🍪 เว็บไซต์นี้ใช้ Cookie",
                        description: `เว็บไซต์นี้ใช้คุกกี้เพื่อเพิ่มประสิทธิภาพ และประสบการณ์ที่ดีในการใช้งานเว็บไซต์ คุณสามารถเลือกความยินยอมแบบแยกส่วนได้ทั้งการใช้งานเว็บไซต์ทั่วไป และการเข้าร่วมโครงการวิจัยเชิงพฤติกรรม โดยมีรายละเอียดการจัดเก็บข้อมูลดังนี้:
1. คุกกี้และการใช้งานเว็บไซต์ทั่วไป (General Website Use): เพื่อการให้บริการระบบ อำนวยความสะดวก และรักษาความเสถียรของแอปพลิเคชัน/เว็บไซต์
2. การเข้าร่วมโครงการวิจัยเชิงพฤติกรรม (Behavioral Research Project)
เข้าร่วมโครงการวิจัยเรื่อง “การพัฒนาแบบจำลองข้อมูลหลายมิติเชิงปัญญาเพื่อทำนายพฤติกรรมผู้ใช้งานแพลตฟอร์มดิจิทัล” โดยระบบจะบันทึกข้อมูลการใช้งานแบบใช้นามแฝง (Pseudonymized ID) เช่น ประวัติการคลิก คำค้นหา ประเภทอุปกรณ์ และตำแหน่งที่ตั้งแบบลดความละเอียด (ระดับอำเภอ/จังหวัด) เพื่อการศึกษาวิจัยทางวิชาการในภาพรวมเท่านั้น
การรักษาความปลอดภัย: ข้อมูลจะถูกเข้ารหัส และจัดเก็บเป็นระยะเวลาไม่เกิน 1 ปีหลังสิ้นสุดโครงการ ก่อนจะถูกลบทำลายอย่างถาวร
สิทธิ์ในการถอนตัว: การเข้าร่วมเป็นไปโดยสมัครใจ ท่านสามารถปฏิเสธ ปิดการติดตามในระบบ หรือถอนตัวเมื่อใดก็ได้โดยไม่มีผลกระทบต่อการใช้งานเว็บไซต์ตามปกติ`,
                        acceptAllBtn: "ยอมรับทั้งหมด",
                        acceptNecessaryBtn: "ไม่ยอมรับ",
                        showPreferencesBtn: "ตั้งค่าคุกกี้",
                        footer: '<a href="PrivacyIndex" style="color: #1c5b9d;">เปิดอ่าน Privacy Policy</a> | <a href="https://drive.google.com/drive/folders/1z7FoVwSF4PH4rcWILzPLZYPyW4yLTnw_?usp=sharing" target="_blank" rel="noopener noreferrer">เอกสารชี้แจงผู้เข้าร่วมการวิจัย</a>\n',
                    },
                    preferencesModal: {
                        title: "การตั้งค่าความเป็นส่วนตัว",
                        acceptAllBtn: "ยอมรับทั้งหมด",
                        acceptNecessaryBtn: "ไม่ยอมรับทั้งหมด",
                        savePreferencesBtn: "บันทึกการตั้งค่าของท่าน",
                        closeIconLabel: "Close modal",
                        serviceCounterLabel: "Service|Services",
                        sections: [
                            {
                                title: "คุกกี้ที่ใช้ในเว็บไซต์",
                                description:
                                    'เว็บไซต์นี้ใช้คุกกี้เพื่อให้แน่ใจว่าการทำงานพื้นฐานของเว็บไซต์ และเพื่อปรับปรุงการใช้งานออนไลน์ของท่าน ท่านสามารถเลือกแต่ละหมวดหมู่เพื่อเข้าร่วม / ไม่ใช้ได้ทุกเมื่อที่ท่านต้องการ สำหรับรายละเอียดเพิ่มเติมเกี่ยวกับคุกกี้และข้อมูลความเป็นส่วนตัว โปรดอ่าน <a style="color: blue;" href="PrivacyIndex" target="_blank">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a>.',
                            },
                            {
                                title: 'คุกกี้ที่จำเป็น <span class="pm__badge">Always Enabled</span>',
                                description:
                                    "คุกกี้พื้นฐานที่จำเป็น เพื่อช่วยให้การทำงานหลักของเว็บไซต์ใช้งานได้ รวมถึงการเข้าถึงพื้นที่ที่ปลอดภัยต่างๆ ของเว็บไซต์ หากไม่มีคุกกี้นี้เว็บไซต์จะไม่สามารถทำงานได้อย่างเหมาะสม และจะใช้งานได้โดยการตั้งค่าเริ่มต้น โดยไม่สามารถปิดการใช้งานได้",
                                linkedCategory: "necessary",
                            },
                            {
                                title: "คุกกี้ประสิทธิภาพและการวิเคราะห์",
                                description:
                                    "คุกกี้ประเภทนี้ใช้เพื่อรวบรวมข้อมูลเกี่ยวกับประสิทธิภาพเว็บไซต์ RCBT-SIP รวมถึงการเยี่ยมชมและการใช้งานเว็บไซต์จากผู้ใช้บริการ เช่น จำนวนผู้เข้าชมที่ใช้เว็บไซต์ของ RCBT-SIP และหน้าเว็บยอดนิยมในหมู่ผู้ใช้บริการของ RCBT-SIP เพื่อปรับปรุงประสบการณ์การใช้งานเว็บไซต์ให้ดียิ่งขึ้น",
                                linkedCategory: "analytics",
                                cookieTable: {
                                    // caption: 'Cookie table',
                                    headers: {
                                        name: "Name",
                                        domain: "Domain",
                                        desc: "Description",
                                    },
                                    body: [
                                        {
                                            name: "_ga",
                                            domain: "rcbt-sip.com/",
                                            desc: "คุกกี้นี้ติดตั้งโดย Google Analytics คุกกี้ใช้เพื่อคำนวณผู้เข้าชม เซสชัน ข้อมูลแคมเปญ และติดตามการใช้งานไซต์สำหรับรายงานการวิเคราะห์ของไซต์ คุกกี้เก็บข้อมูลโดยไม่ระบุชื่อและกำหนดหมายเลขที่สร้างขึ้นแบบสุ่มเพื่อระบุผู้เยี่ยมชมที่ไม่ซ้ำใคร",
                                        },
                                        {
                                            name: "_gid",
                                            domain: "rcbt-sip.com/",
                                            desc: "คุกกี้นี้ติดตั้งโดย Google Analytics คุกกี้ใช้เพื่อเก็บข้อมูลว่าผู้เยี่ยมชมใช้เว็บไซต์อย่างไร และช่วยในการสร้างรายงานการวิเคราะห์ว่าเว็บไซต์เป็นอย่างไร ข้อมูลที่รวบรวมรวมถึงจำนวนผู้เยี่ยมชม แหล่งที่มาและหน้าที่เยี่ยมชมในรูปแบบนิรนาม",
                                        },
                                    ],
                                },
                            },
                            {
                                title: "การเข้าร่วมโครงการวิจัยเชิงพฤติกรรม",
                                description:
                                    'หมวดนี้ใช้สำหรับการเก็บข้อมูลพฤติกรรมการใช้งานเพื่อการวิจัยตามนโยบายที่กำหนด หากไม่ยินยอม ระบบจะไม่เปิดใช้ตัวติดตามงานวิจัย คุณสามารถอ่านรายละเอียดได้ที่ <a style="color: blue;" href="https://drive.google.com/drive/folders/1z7FoVwSF4PH4rcWILzPLZYPyW4yLTnw_?usp=sharing" target="_blank" rel="noopener noreferrer">เอกสารชี้แจงผู้เข้าร่วมการวิจัย (Participant Information Sheet)</a>.',
                                linkedCategory: "behavioralResearch",
                            },
                            {
                                title: 'หากท่านมีปัญหา หรือข้อสงสัยโปรดติดต่อเราที่ <a style="color: blue;" =href="SupportPage" target="_blank">ติดต่อเรา</a>',
                                // description: "Powered by cookie-consent"
                            },
                        ],
                    },
                },
            },
            autoDetect: "browser",
        },
    });

    watchConsentModal();
    syncTrackerConsentFromCookie();
};

const CookieConsentVue = {
    install(app) {
        app.config.globalProperties.$CookieConsent = CookieConsent;
        initCookieConsent();
    },
};

export default CookieConsentVue;
